import React from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Avatar,
  Box,
  Paper,
  Divider
} from "@mui/material";
import { Star as StarIcon } from "@mui/icons-material";

const recommendationsData = [
  {
    name: "Dr. Ghassan Alkadi",
    role: "Professor, Southeastern Louisiana University",
    text: "I strongly recommend Subin Bista, an outstanding Computer Science student at Southeastern Louisiana University whom I found to be highly capable, disciplined, and intellectually curious.",
    avatar: "GA"
  },
  {
    name: "Paul Petracca",
    role: "Senior Technical Consultant, DXC Technology",
    text: "I mentored Subin during their internship and was impressed by their eagerness to learn, strong work ethic, and ability to deliver high-quality work both independently and as part of a team.",
    avatar: "PP"
  },
  {
    name: "Niraj Bhatta",
    role: "Student, Southeastern Louisiana University",
    text: "I worked with Subin on several projects and found him to be a dependable, collaborative teammate with strong leadership and problem-solving skills who consistently delivers great results.",
    avatar: "NB"
  },
];

export const RecommendationsSection = () => {
  return (
    <Paper elevation={0} sx={{ p: 4, mb: 4, borderRadius: 3, boxShadow: "0 2px 8px rgba(0,0,0,0.08)" }}>
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        <StarIcon sx={{ mr: 1, verticalAlign: "middle", color: "#FFD700" }} />
        Recommendations
      </Typography>
      <Divider sx={{ my: 2 }} />
      <Grid container spacing={3}>
        {recommendationsData.map((rec, idx) => (
          <Grid item xs={12} md={6} key={idx}>
            <Card
              elevation={0}
              sx={{
                height: "100%",
                backgroundColor: "#FFF9E6",
                borderRadius: 2
              }}
            >
              <CardContent>
                <Typography variant="body2" sx={{ fontStyle: "italic", mb: 2 }}>
                  "{rec.text}"
                </Typography>
                <Box sx={{ display: "flex", alignItems: "center", mt: 2 }}>
                  <Avatar sx={{ bgcolor: "#667eea", mr: 2, width: 50, height: 50 }}>
                    {rec.avatar}
                  </Avatar>
                  <Box>
                    <Typography variant="subtitle2" fontWeight="bold">
                      {rec.name}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {rec.role}
                    </Typography>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
};
